import React from "react"

import type { PaperProps } from "./Paper"

import { Paper } from "./Paper"
import { useBreakpointValue } from "./useBreakpointValue"
import type { View } from "react-native"

export const ListItemCard = React.forwardRef<View, PaperProps>(
  function ListItemCard({ children, ...rest }, ref) {
    const getValue = useBreakpointValue()
    return (
      <Paper
        ref={ref}
        pb={"$2"}
        pt={"$2"}
        px={"$4"}
        rounded={getValue({ sm: "$default" })}
        {...rest}
      >
        {children}
      </Paper>
    )
  },
)
